import { Button } from '@/components';
import { useBreadcrumbs } from '@/hooks';
import { Box, Flex, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { BiMenu, BiMenuAltRight } from 'react-icons/bi';
import { Outlet } from 'react-router-dom';
import '../../assets/css/admin.scss';
import Breadcrumb from './LayoutBreadcrumb';
import LeftMenu from './LayoutSidebar';
import { LayoutUser } from './LayoutUser';
import { NavigationGuard } from './NavigationGuard';

function LayoutAdmin() {
  const [collapse, setCollapse] = useState<boolean>(false);
  const { breadcrumbs } = useBreadcrumbs();

  const handleToggleCollapse = () => {
    setCollapse((prev) => !prev);
  };

  return (
    <Box minH="100vh" className={collapse ? 'layout-collapse' : ''}>
      <Helmet>
        <title>{breadcrumbs[breadcrumbs.length - 1]?.name}</title>
      </Helmet>
      <Flex px={'22px'} py={'17px'} overflowX="hidden" >
        <LeftMenu onToggleCollapse={handleToggleCollapse} collapse={collapse} />
        <Box width="full" height="calc(100vh - 34px)">
          <HStack spaceX={{ base: '0', md: '6' }} className="app-header">
            <Flex flex="1" justifyContent="space-between" alignItems="center">
              <Flex alignItems="center" justifyContent="flex-start">
                <Button onClick={handleToggleCollapse} variant="plain">
                  {collapse ? (
                    <BiMenuAltRight style={{ width: 24, height: 24 }} />
                  ) : (
                    <BiMenu style={{ width: 24, height: 24 }} />
                  )}
                </Button>
                <Breadcrumb />
              </Flex>

              <LayoutUser />
            </Flex>
          </HStack>

          {/* content */}
          <Box className="app-content">
            <div className="app-content-wrapper">
              <NavigationGuard>
                <Outlet />
              </NavigationGuard>
            </div>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export { LayoutAdmin };
